
export function findUnit(sensorParameters, sensorTypeDevice) {
    const unit = sensorParameters
        .filter(sensor => sensor.sensor.tipoSensor._id === sensorTypeDevice._id)
        .map(sensor => ({
            unit: sensor.sensor.unidad,
        }))[0];

    return unit;
}